import crudBuilder from "./crudBuilder";
import {
  DeleteAddressParams,
  DeleteApiKeyParams,
  DeleteAssetParams,
  DeleteAttributeConnectionParams,
  DeleteAttributeParams,
  DeleteAttributeSetParams,
  DeleteAttributeValueParams,
  DeleteCategoryParams,
  DeleteCommoditiesOnContractsParams,
  DeleteCommodityParams,
  DeleteCompanyParams,
  DeleteContactParams,
  DeleteContractParams,
  DeleteDashboardParams,
  DeleteDeploymentLineItemParams,
  DeleteDeploymentParams,
  DeleteFindSkuParams,
  DeleteIncomingShipmentParams,
  DeleteIncomingShipmentReportParams,
  DeleteLocationParams,
  DeleteManufacturerParams,
  DeleteManyAddressParams,
  DeleteManyApiKeyParams,
  DeleteManyAssetParams,
  DeleteManyAttributeConnectionParams,
  DeleteManyAttributeParams,
  DeleteManyAttributeSetParams,
  DeleteManyAttributeValueParams,
  DeleteManyCategoryParams,
  DeleteManyCommoditiesOnContractsParams,
  DeleteManyCommodityParams,
  DeleteManyCompanyParams,
  DeleteManyContactParams,
  DeleteManyContractParams,
  DeleteManyDashboardParams,
  DeleteManyDeploymentLineItemParams,
  DeleteManyDeploymentParams,
  DeleteManyFindSkuParams,
  DeleteManyIncomingShipmentParams,
  DeleteManyIncomingShipmentReportParams,
  DeleteManyLocationParams,
  DeleteManyManufacturerParams,
  DeleteManyMasterItemParams,
  DeleteManyNotificationTypeParams,
  DeleteManyPermissionParams,
  DeleteManyPortalCompanyParams,
  DeleteManyPrintParams,
  DeleteManyPrintTemplateParams,
  DeleteManyPrinterParams,
  DeleteManyProjectParams,
  DeleteManyProjectTypeFieldConnectionParams,
  DeleteManyProjectTypeParams,
  DeleteManyReturnLineItemParams,
  DeleteManyReturnParams,
  DeleteManyRoleParams,
  DeleteManyRoleResourceParams,
  DeleteManyRolesOnUsersParams,
  DeleteManySalesOrderLineItemParams,
  DeleteManySalesOrderParams,
  DeleteManySkidParams,
  DeleteManySpaceParams,
  DeleteManySpaceSendgridParams,
  DeleteManySpaceSubdomainParams,
  DeleteManyUploadParams,
  DeleteManyUserParams,
  DeleteManyUserTablePreferencesParams,
  DeleteManyUsersRoleParams,
  DeleteManyVendorConnectionParams,
  DeleteManyVendorParams,
  DeleteManyVendorTypeParams,
  DeleteManyWarehouseParams,
  DeleteManyWorkflowStepParams,
  DeleteManyWorkflowTransitionParams,
  DeleteMasterItemParams,
  DeleteNotificationTypeParams,
  DeletePermissionParams,
  DeletePortalCompanyParams,
  DeletePrintParams,
  DeletePrintTemplateParams,
  DeletePrinterParams,
  DeleteProjectParams,
  DeleteProjectTypeFieldConnectionParams,
  DeleteProjectTypeParams,
  DeleteReturnLineItemParams,
  DeleteReturnParams,
  DeleteRoleParams,
  DeleteRoleResourceParams,
  DeleteRolesOnUsersParams,
  DeleteSalesOrderLineItemParams,
  DeleteSalesOrderParams,
  DeleteSkidParams,
  DeleteSpaceParams,
  DeleteSpaceSendgridParams,
  DeleteSpaceSubdomainParams,
  DeleteUploadParams,
  DeleteUserParams,
  DeleteUserTablePreferencesParams,
  DeleteUsersRoleParams,
  DeleteVendorConnectionParams,
  DeleteVendorParams,
  DeleteVendorTypeParams,
  DeleteWarehouseParams,
  DeleteWorkflowStepParams,
  DeleteWorkflowTransitionParams,
  Filter,
  GetAddressParams,
  // Generic types to re-export
  GetAllSettings,
  GetApiKeyParams,
  GetAssetParams,
  GetAttributeConnectionParams,
  GetAttributeParams,
  GetAttributeSetParams,
  GetAttributeValueParams,
  GetCategoryParams,
  GetCommoditiesOnContractsParams,
  GetCommodityParams,
  GetCompanyParams,
  GetContactParams,
  GetContractParams,
  GetDashboardParams,
  GetDeploymentLineItemParams,
  GetDeploymentParams,
  GetFindSkuParams,
  GetIncomingShipmentParams,
  GetIncomingShipmentReportParams,
  GetLocationParams,
  GetManufacturerParams,
  GetMasterItemParams,
  GetNotificationTypeParams,
  GetPermissionParams,
  GetPortalCompanyParams,
  GetPrintParams,
  GetPrintTemplateParams,
  GetPrinterParams,
  GetProjectParams,
  GetProjectTypeFieldConnectionParams,
  GetProjectTypeParams,
  GetReturnLineItemParams,
  GetReturnParams,
  GetRoleParams,
  GetRoleResourceParams,
  GetRolesOnUsersParams,
  GetSalesOrderLineItemParams,
  GetSalesOrderParams,
  GetSkidParams,
  GetSpaceParams,
  GetSpaceSendgridParams,
  GetSpaceSubdomainParams,
  GetUploadParams,
  GetUserParams,
  GetUserTablePreferencesParams,
  GetUsersRoleParams,
  GetVendorConnectionParams,
  GetVendorParams,
  GetVendorTypeParams,
  GetWarehouseParams,
  GetWorkflowStepParams,
  GetWorkflowTransitionParams,
  PutAddressParams,
  PutApiKeyParams,
  PutAssetParams,
  PutAttributeConnectionParams,
  PutAttributeParams,
  PutAttributeSetParams,
  PutAttributeValueParams,
  PutCategoryParams,
  PutCommoditiesOnContractsParams,
  PutCommodityParams,
  PutCompanyParams,
  PutContactParams,
  PutContractParams,
  PutDashboardParams,
  PutDeploymentLineItemParams,
  PutDeploymentParams,
  PutFindSkuParams,
  PutIncomingShipmentParams,
  PutIncomingShipmentReportParams,
  PutLocationParams,
  PutManufacturerParams,
  PutManyAddressParams,
  PutManyApiKeyParams,
  PutManyAssetParams,
  PutManyAttributeConnectionParams,
  PutManyAttributeParams,
  PutManyAttributeSetParams,
  PutManyAttributeValueParams,
  PutManyCategoryParams,
  PutManyCommoditiesOnContractsParams,
  PutManyCommodityParams,
  PutManyCompanyParams,
  PutManyContactParams,
  PutManyContractParams,
  PutManyDashboardParams,
  PutManyDeploymentLineItemParams,
  PutManyDeploymentParams,
  PutManyFindSkuParams,
  PutManyIncomingShipmentParams,
  PutManyIncomingShipmentReportParams,
  PutManyLocationParams,
  PutManyManufacturerParams,
  PutManyMasterItemParams,
  PutManyNotificationTypeParams,
  PutManyPermissionParams,
  PutManyPortalCompanyParams,
  PutManyPrintParams,
  PutManyPrintTemplateParams,
  PutManyPrinterParams,
  PutManyProjectParams,
  PutManyProjectTypeFieldConnectionParams,
  PutManyProjectTypeParams,
  PutManyReturnLineItemParams,
  PutManyReturnParams,
  PutManyRoleParams,
  PutManyRoleResourceParams,
  PutManyRolesOnUsersParams,
  PutManySalesOrderLineItemParams,
  PutManySalesOrderParams,
  PutManySkidParams,
  PutManySpaceParams,
  PutManySpaceSendgridParams,
  PutManySpaceSubdomainParams,
  PutManyUploadParams,
  PutManyUserParams,
  PutManyUserTablePreferencesParams,
  PutManyUsersRoleParams,
  PutManyVendorConnectionParams,
  PutManyVendorParams,
  PutManyVendorTypeParams,
  PutManyWarehouseParams,
  PutManyWorkflowStepParams,
  PutManyWorkflowTransitionParams,
  PutMasterItemParams,
  PutNotificationTypeParams,
  PutPermissionParams,
  PutPortalCompanyParams,
  PutPrintParams,
  PutPrintTemplateParams,
  PutPrinterParams,
  PutProjectParams,
  PutProjectTypeFieldConnectionParams,
  PutProjectTypeParams,
  PutReturnLineItemParams,
  PutReturnParams,
  PutRoleParams,
  PutRoleResourceParams,
  PutRolesOnUsersParams,
  PutSalesOrderLineItemParams,
  PutSalesOrderParams,
  PutSkidParams,
  PutSpaceParams,
  PutSpaceSendgridParams,
  PutSpaceSubdomainParams,
  PutUploadParams,
  PutUserParams,
  PutUserTablePreferencesParams,
  PutUsersRoleParams,
  PutVendorConnectionParams,
  PutVendorParams,
  PutVendorTypeParams,
  PutWarehouseParams,
  PutWorkflowStepParams,
  PutWorkflowTransitionParams,
  Query,
  RequestFilter,
  UploadAddressParams,
  UploadApiKeyParams,
  UploadAssetParams,
  UploadAttributeConnectionParams,
  UploadAttributeParams,
  UploadAttributeSetParams,
  UploadAttributeValueParams,
  UploadCategoryParams,
  UploadCommoditiesOnContractsParams,
  UploadCommodityParams,
  UploadCompanyParams,
  UploadContactParams,
  UploadContractParams,
  UploadDashboardParams,
  UploadDeploymentLineItemParams,
  UploadDeploymentParams,
  UploadFindSkuParams,
  UploadIncomingShipmentParams,
  UploadIncomingShipmentReportParams,
  UploadLocationParams,
  UploadManufacturerParams,
  UploadMasterItemParams,
  UploadNotificationTypeParams,
  UploadPermissionParams,
  UploadPortalCompanyParams,
  UploadPrintParams,
  UploadPrintTemplateParams,
  UploadPrinterParams,
  UploadProjectParams,
  UploadProjectTypeFieldConnectionParams,
  UploadProjectTypeParams,
  UploadReturnLineItemParams,
  UploadReturnParams,
  UploadRoleParams,
  UploadRoleResourceParams,
  UploadRolesOnUsersParams,
  UploadSalesOrderLineItemParams,
  UploadSalesOrderParams,
  UploadSkidParams,
  UploadSpaceParams,
  UploadSpaceSendgridParams,
  UploadSpaceSubdomainParams,
  UploadUploadParams,
  UploadUserParams,
  UploadUserTablePreferencesParams,
  UploadUsersRoleParams,
  UploadVendorConnectionParams,
  UploadVendorParams,
  UploadVendorTypeParams,
  UploadWarehouseManyParams,
  UploadWorkflowStepParams,
  UploadWorkflowTransitionParams,
  GetPortalLocationParams,
  PutPortalLocationParams,
  PutManyPortalLocationParams,
  DeletePortalLocationParams,
  DeleteManyPortalLocationParams,
  UploadPortalLocationParams,
  GetProjectSalesOrdersParams,
  GetWipeOSAttributeParams,
  PutWipeOSAttributeParams,
  PutManyWipeOSAttributeParams,
  IncomingShipmentReportRecordCountRoutes,
  GetIncomingShipmentReportRecordCountParams,
  R2GradingOptionRoutes,
  GetR2GradingOptionParams,
  PutR2GradingOptionParams,
  PutManyR2GradingOptionParams,
  DeleteR2GradingOptionParams,
  DeleteManyR2GradingOptionParams,
  UploadR2GradingOptionParams,
  GetSalesOrderReportParams,
  GetHistoryParams,
  GetAssetHistoryParams,
  GetCustomReportParams,
  PutCustomReportParams,
  PutManyCustomReportParams,
  DeleteCustomReportParams,
  DeleteManyCustomReportParams,
  UploadCustomReportParams,
  GetParamsWithSpace,
  GetParams,
} from "./types";

const companyRoutes = ["company"] as const;
const companyCrud = crudBuilder({ routes: companyRoutes });

const mergeCompanyRoutes = ["company", "merge"];
const mergeCompanyCrud = crudBuilder({ routes: mergeCompanyRoutes, spaceIsOptional: true });

const userRoutes = ["user"] as const;
const userCrud = crudBuilder({ routes: userRoutes });

const userValidateRoutes = ["user", "validate"] as const;
const userValidateCrud = crudBuilder({ routes: userValidateRoutes, spaceIsOptional: true });

const spaceRoutes = ["space"] as const;
const spaceCrud = crudBuilder({ routes: spaceRoutes, spaceIsOptional: true });

const masterItemRoutes = ["masterItem"] as const;
const masterItemCrud = crudBuilder({ routes: masterItemRoutes });

const mergeMasterItemRoutes = ["masterItem", "merge"];
const mergeMasterItemCrud = crudBuilder({ routes: mergeMasterItemRoutes, spaceIsOptional: true });

const roleRoutes = ["role"] as const;
const roleCrud = crudBuilder({ routes: roleRoutes });

const usersRoleRoutes = ["users-role"] as const;
const usersRoleCrud = crudBuilder({ routes: usersRoleRoutes });

const permissionRoutes = ["permission"] as const;
const permissionCrud = crudBuilder({ routes: permissionRoutes, spaceIsOptional: true });

const roleResourceRoutes = ["role-resource"] as const;
const roleResourceCrud = crudBuilder({ routes: roleResourceRoutes, spaceIsOptional: true });

const spaceSubdomainRoutes = ["space", "subdomain"] as const;
const spaceSubdomainCrud = crudBuilder({ routes: spaceSubdomainRoutes, spaceIsOptional: true });

const uploadRoutes = ["upload"] as const;
const uploadCrud = crudBuilder({ routes: uploadRoutes });

const contactRoutes = ["contact"] as const;
const contactCrud = crudBuilder({ routes: contactRoutes });

const userTablePreferencesRoutes = ["user", "table-preferences"] as const;
const userTablePreferencesCrud = crudBuilder({ routes: userTablePreferencesRoutes, spaceIsOptional: true });

const addressRoutes = ["address"] as const;
const addressCrud = crudBuilder({ routes: addressRoutes });

const categoryRoutes = ["category"] as const;
const categoryCrud = crudBuilder({ routes: categoryRoutes });

const commodityRoutes = ["commodity"] as const;
const commodityCrud = crudBuilder({ routes: commodityRoutes });

const contractRoutes = ["contract"] as const;
const contractCrud = crudBuilder({ routes: contractRoutes });

const vendorRoutes = ["vendor"] as const;
const vendorCrud = crudBuilder({ routes: vendorRoutes });

const projectRoutes = ["project"] as const;
const projectCrud = crudBuilder({ routes: projectRoutes });

const workflowStepRoutes = ["workflow-step"] as const;
const workflowStepCrud = crudBuilder({ routes: workflowStepRoutes });

const workflowTransitionRoutes = ["workflow-transition"] as const;
const workflowTransitionCrud = crudBuilder({ routes: workflowTransitionRoutes });

const manufacturerRoutes = ["manufacturer"] as const;
const manufacturerCrud = crudBuilder({ routes: manufacturerRoutes });

const mergeManufacturerRoutes = ["manufacturer", "merge"];
const mergeManufacturerCrud = crudBuilder({ routes: mergeManufacturerRoutes, spaceIsOptional: true });

const warehouseRoutes = ["warehouse"] as const;
const warehouseCrud = crudBuilder({ routes: warehouseRoutes });

const locationRoutes = ["location"] as const;
const locationCrud = crudBuilder({ routes: locationRoutes });

const spaceSendgridRoutes = ["space", "sendgrid"] as const;
const spaceSendgridCrud = crudBuilder({ routes: spaceSendgridRoutes, spaceIsOptional: true });

const attributeRoutes = ["attribute"] as const;
const attributeCrud = crudBuilder({ routes: attributeRoutes });

const mergeAttributeRoutes = ["attribute", "merge"];
const mergeAttributeCrud = crudBuilder({ routes: mergeAttributeRoutes, spaceIsOptional: true });

const attributeValueRoutes = ["attribute-value"] as const;
const attributeValueCrud = crudBuilder({ routes: attributeValueRoutes });

const mergeAttributeValueRoutes = ["attribute-value", "merge"];
const mergeAttributeValueCrud = crudBuilder({ routes: mergeAttributeValueRoutes, spaceIsOptional: true });

const attributeSetRoutes = ["attribute-set"] as const;
const attributeSetCrud = crudBuilder({ routes: attributeSetRoutes });

const attributeConnectionRoutes = ["attribute-connection"] as const;
const attributeConnectionCrud = crudBuilder({ routes: attributeConnectionRoutes });

const projectTypeRoutes = ["project-type"] as const;
const projectTypeCrud = crudBuilder({ routes: projectTypeRoutes });

const vendorTypeRoutes = ["vendor-type"] as const;
const vendorTypeCrud = crudBuilder({ routes: vendorTypeRoutes });

const rolesOnUsersRoutes = ["role-on-users"] as const;
const rolesOnUsersCrud = crudBuilder({ routes: rolesOnUsersRoutes });

const incomingShipmentRoutes = ["incoming-shipment"] as const;
const incomingShipmentsCrud = crudBuilder({ routes: incomingShipmentRoutes });

const vendorConnectionRoutes = ["vendor-connection"] as const;
const vendorConnectionCrud = crudBuilder({ routes: vendorConnectionRoutes });

const skidRoutes = ["skid"] as const;
const skidCrud = crudBuilder({ routes: skidRoutes });

const notificationTypeRoutes = ["notification-type"] as const;
const notificationTypeCrud = crudBuilder({ routes: notificationTypeRoutes });

const assetRoutes = ["asset"] as const;
const assetCrud = crudBuilder({ routes: assetRoutes });

const assetSerialRoutes = ["asset", "serial-number"] as const;
const assetSerialCrud = crudBuilder({ routes: assetSerialRoutes });

const dashboardRoutes = ["dashboard"] as const;
const dashboardCrud = crudBuilder({ routes: dashboardRoutes });

const commoditiesOnContractsRoutes = ["commodities-on-contracts"] as const;
const commoditiesOnContractsCrud = crudBuilder({ routes: commoditiesOnContractsRoutes });

const salesOrderRoutes = ["sales-order"] as const;
const salesOrderCrud = crudBuilder({ routes: salesOrderRoutes });

const salesOrderLineItemRoutes = ["sales-order", "line-item"] as const;
const salesOrderLineItemCrud = crudBuilder({ routes: salesOrderLineItemRoutes });

const findSKURoutes = ["find-sku"] as const;
const findSKUCrud = crudBuilder({ routes: findSKURoutes });

const printRoutes = ["print"] as const;
const printCrud = crudBuilder({ routes: printRoutes });

const printerRoutes = ["printer"] as const;
const printerCrud = crudBuilder({ routes: printerRoutes });

const printTemplateRoutes = ["print-template"] as const;
const printTemplateCrud = crudBuilder({ routes: printTemplateRoutes });

const returnRoutes = ["return"] as const;
const returnCrud = crudBuilder({ routes: returnRoutes });

const projectTypeFieldConnectionRoutes = ["project-type", "project-type-field-connection"] as const;
const projectTypeFieldConnectionCrud = crudBuilder({ routes: projectTypeFieldConnectionRoutes });

const incomingShipmentReportRoutes = ["incoming-shipment", "report"] as const;
const incomingShipmentReportCrud = crudBuilder({ routes: incomingShipmentReportRoutes });

const deploymentRoutes = ["deployment"] as const;
const deploymentCrud = crudBuilder({ routes: deploymentRoutes });

const returnLineItemRoutes = ["return", "line-item"] as const;
const returnLineItemCrud = crudBuilder({ routes: returnLineItemRoutes });

const deploymentLineItemRoutes = ["deployment", "line-item"] as const;
const deploymentLineItemCrud = crudBuilder({ routes: deploymentLineItemRoutes });

const apiKeyRoutes = ["api-key"] as const;
const apiKeyCrud = crudBuilder({ routes: apiKeyRoutes });

const portalCompanyRoutes = ["dataknox-portal", "company"] as const;
const portalCompanyCrud = crudBuilder({ routes: portalCompanyRoutes, spaceIsOptional: true });

const portalLocationRoutes = ["dataknox-portal", "location"] as const;
const portalLocationCrud = crudBuilder({ routes: portalLocationRoutes, spaceIsOptional: true });

const portalJobRoutes = ["dataknox-portal", "job"] as const;
const portalJobCrud = crudBuilder({ routes: portalJobRoutes, spaceIsOptional: true });

const projectSalesOrdersRoutes = ["project", "sales-orders"] as const;
const projectSalesOrdersCrud = crudBuilder({ routes: projectSalesOrdersRoutes, spaceIsOptional: true });

const printerPrintNodeSyncRoutes = ["printer", "print-node-sync"] as const;
const printerPrintNodeSyncCrud = crudBuilder({ routes: printerPrintNodeSyncRoutes, spaceIsOptional: true });

const userAutoPrintRoutes = ["user", "auto-print"] as const;
const userAutoPrintCrud = crudBuilder({ routes: userAutoPrintRoutes, spaceIsOptional: true });

const wipeOSAttributeRoutes = ["wipeos-attribute"] as const;
const wipeOSAttributeCrud = crudBuilder({ routes: wipeOSAttributeRoutes, spaceIsOptional: true });

const incomingShipmentReportRecordCountRoutes = ["incoming-shipment", "report", "record-count"] as const;
const incomingShipmentReportRecordCountCrud = crudBuilder({ routes: incomingShipmentReportRecordCountRoutes, spaceIsOptional: true });

const r2GradingOptionRoutes = ["r2-grading-option"] as const;
const r2GradingOptionCrud = crudBuilder({ routes: r2GradingOptionRoutes, spaceIsOptional: true });

const exportRoutes = ["export"] as const;
const exportCrud = crudBuilder({ routes: exportRoutes, spaceIsOptional: false });

const salesOrderReportRoutes = ["sales-order", "report"] as const;
const salesOrderReportCrud = crudBuilder({ routes: salesOrderReportRoutes });

const historyRoutes = ["logs"] as const;
const historyCrud = crudBuilder({ routes: historyRoutes });

const assetHistoryRoutes = ["asset", "logs"] as const;
const assetHistoryCrud = crudBuilder({ routes: assetHistoryRoutes });

const locationAuditRoutes = ["location-audit"] as const;
const locationAuditCrud = crudBuilder({ routes: locationAuditRoutes, spaceIsOptional: false });

const assetAuditRoutes = ["asset-audit"] as const;
const assetAuditCrud = crudBuilder({ routes: assetAuditRoutes });

const purchaseOrderRoutes = ["purchase-order"] as const;
const purchaseOrderCrud = crudBuilder({ routes: purchaseOrderRoutes, spaceIsOptional: false });

const purchaseOrderLineItemRoutes = ["purchase-order", "line-item"] as const;
const purchaseOrderLineItemCrud = crudBuilder({ routes: purchaseOrderLineItemRoutes });

const mergeAssetRoutes = ["asset", "merge"] as const;
const mergeAssetCrud = crudBuilder({ routes: mergeAssetRoutes });

const splitAllocateAssetRoutes = ["asset", "split-allocate"] as const;
const splitAllocateAssetCrud = crudBuilder({ routes: splitAllocateAssetRoutes });

const checkVersionRoutes = ["check-version"] as const;
const checkVersionCrud = crudBuilder({ routes: checkVersionRoutes, spaceIsOptional: true });

const bulkUpdateRoutes = ["bulk-update"] as const;
const bulkUpdateCrud = crudBuilder({ routes: bulkUpdateRoutes, spaceIsOptional: false });

const customReportRoutes = ["custom-report"] as const;
const customReportCrud = crudBuilder({ routes: customReportRoutes, spaceIsOptional: true });

const serviceRoutes = ["service"] as const;
const serviceCrud = crudBuilder({ routes: serviceRoutes, spaceIsOptional: false });

const contractServiceConnectionRoutes = ["contract", "service"] as const;
const contractServiceConnectionCrud = crudBuilder({ routes: contractServiceConnectionRoutes, spaceIsOptional: false });

const contractCategoryConsignmentRuleRoutes = ["contract", "category"] as const;
const contractCategoryConsignmentRuleCrud = crudBuilder({ routes: contractCategoryConsignmentRuleRoutes, spaceIsOptional: false });

const projectSettlementReportRoutes = ["project", "settlement-report"] as const;
const projectSettlementReportCrud = crudBuilder({ routes: projectSettlementReportRoutes, spaceIsOptional: false });

const serviceHourRoutes = ["service-hour"] as const;
const serviceHourCrud = crudBuilder({ routes: serviceHourRoutes, spaceIsOptional: false });

const superAdminUserRoutes = ["super-admin"] as const;
const superAdminUserCrud = crudBuilder({ routes: superAdminUserRoutes, spaceIsOptional: true });

const userInviteEmailRoutes = ["user", "invite"] as const;
const userInviteEmailCrud = crudBuilder({ routes: userInviteEmailRoutes, spaceIsOptional: false });

const superAdminUserInviteEmailRoutes = ["super-admin", "invite"] as const;
const superAdminUserInviteEmailCrud = crudBuilder({ routes: superAdminUserInviteEmailRoutes, spaceIsOptional: true });

const assetStatusActivityRoutes = ["asset-status-activity"] as const;
const assetStatusActivityCrud = crudBuilder({ routes: assetStatusActivityRoutes, spaceIsOptional: false });

const userAssetActivityRoutes = ["user-asset-activity"] as const;
const userAssetActivityCrud = crudBuilder({ routes: userAssetActivityRoutes, spaceIsOptional: false });

const assetTransactionRoutes = ["asset-transaction"] as const;
const assetTransactionCrud = crudBuilder({ routes: assetTransactionRoutes, spaceIsOptional: false });

export {
  // Address
  addressCrud,
  addressRoutes,
  // Api Key
  apiKeyCrud,
  apiKeyRoutes,
  // Asset
  assetCrud,
  assetRoutes,
  // Asset Serial (searching single asset by serial number)
  assetSerialRoutes,
  assetSerialCrud,
  // Attribute Connection
  attributeConnectionCrud,
  attributeConnectionRoutes,
  // Attribute
  attributeCrud,
  attributeRoutes,
  mergeAttributeCrud,
  mergeAttributeRoutes,
  // Attribute Set
  attributeSetCrud,
  attributeSetRoutes,
  // Attribute Value
  attributeValueCrud,
  attributeValueRoutes,
  mergeAttributeValueCrud,
  mergeAttributeValueRoutes,
  // Category
  categoryCrud,
  categoryRoutes,
  // Commodities On Contracts
  commoditiesOnContractsCrud,
  commoditiesOnContractsRoutes,
  // Commodity
  commodityCrud,
  commodityRoutes,
  companyCrud,

  // Company
  companyRoutes,
  mergeCompanyRoutes,
  mergeCompanyCrud,

  // Contact
  contactCrud,
  contactRoutes,
  // Contract
  contractCrud,
  contractRoutes,
  // Dashboard
  dashboardCrud,
  dashboardRoutes,
  // Deployment
  deploymentCrud,
  // Deployment Line Item
  deploymentLineItemCrud,
  deploymentLineItemRoutes,
  deploymentRoutes,
  // Find SKU
  findSKUCrud,
  findSKURoutes,
  // Incoming Shipment Report
  incomingShipmentReportCrud,
  incomingShipmentReportRoutes,
  // Incoming Shipment
  incomingShipmentRoutes,
  incomingShipmentsCrud,
  // Location
  locationCrud,
  locationRoutes,
  // Manufacturer
  manufacturerCrud,
  manufacturerRoutes,
  mergeManufacturerCrud,
  mergeManufacturerRoutes,
  // Master Item
  masterItemCrud,
  masterItemRoutes,
  mergeMasterItemCrud,
  mergeMasterItemRoutes,
  // Notification Type
  notificationTypeCrud,
  notificationTypeRoutes,
  permissionCrud,
  // Permission
  permissionRoutes,
  // Portal Company
  portalCompanyCrud,
  portalCompanyRoutes,
  printCrud,
  // Print
  printRoutes,
  // Print Template
  printTemplateCrud,
  printTemplateRoutes,
  // Printer
  printerCrud,
  printerRoutes,
  // Project
  projectCrud,
  projectRoutes,
  // Project Type
  projectTypeCrud,
  // Project Type Field Connection
  projectTypeFieldConnectionCrud,
  projectTypeFieldConnectionRoutes,
  projectTypeRoutes,
  // Return
  returnCrud,
  // Return Line Item
  returnLineItemCrud,
  returnLineItemRoutes,
  returnRoutes,
  roleCrud,
  // Role Resource
  roleResourceCrud,
  roleResourceRoutes,
  // Role
  roleRoutes,
  // Roles On Users
  rolesOnUsersCrud,
  rolesOnUsersRoutes,
  // Sales Order
  salesOrderCrud,
  // Sales Order Line Item
  salesOrderLineItemCrud,
  salesOrderLineItemRoutes,
  salesOrderRoutes,
  skidCrud,
  // Sales Order Reports
  salesOrderReportCrud,
  salesOrderReportRoutes,
  // Skid
  skidRoutes,
  spaceCrud,
  // Space
  spaceRoutes,
  // Space Sendgrid
  spaceSendgridCrud,
  spaceSendgridRoutes,
  // Space Subdomain
  spaceSubdomainCrud,
  spaceSubdomainRoutes,
  // Upload
  uploadCrud,
  uploadRoutes,
  // User
  userCrud,
  userRoutes,

  // User Validate Crud
  userValidateRoutes,
  userValidateCrud,

  // User Table Preferences
  userTablePreferencesCrud,
  userTablePreferencesRoutes,
  usersRoleCrud,
  // Users Role
  usersRoleRoutes,
  vendorConnectionCrud,
  // Vendor Connection
  vendorConnectionRoutes,
  // Vendor
  vendorCrud,
  vendorRoutes,
  // Vendor Type
  vendorTypeCrud,
  vendorTypeRoutes,
  // Warehouse
  warehouseCrud,
  warehouseRoutes,
  // Workflow Step
  workflowStepCrud,
  workflowStepRoutes,
  // Workflow Transition
  workflowTransitionCrud,
  workflowTransitionRoutes,

  // Portal Location
  portalLocationCrud,
  portalLocationRoutes,

  // Portal Job
  portalJobCrud,
  portalJobRoutes,

  // Project Sales Orders
  projectSalesOrdersCrud,
  projectSalesOrdersRoutes,

  // Printer Print Node Sync
  printerPrintNodeSyncRoutes,
  printerPrintNodeSyncCrud,

  // User Auto Print
  userAutoPrintRoutes,
  userAutoPrintCrud,

  // WipeOS Attribute
  wipeOSAttributeRoutes,
  wipeOSAttributeCrud,

  // Incoming Shipment Report Record Count
  incomingShipmentReportRecordCountRoutes,
  incomingShipmentReportRecordCountCrud,

  // R2 Grading Option Record Count
  r2GradingOptionRoutes,
  r2GradingOptionCrud,

  // Export Crud
  exportRoutes,
  exportCrud,

  // History Crud
  historyRoutes,
  historyCrud,

  // Asset History Crud
  assetHistoryRoutes,
  assetHistoryCrud,

  // Location Audit Crud
  locationAuditRoutes,
  locationAuditCrud,

  // Asset Audit Crud
  assetAuditRoutes,
  assetAuditCrud,

  // Purchase Order Crud
  purchaseOrderRoutes,
  purchaseOrderCrud,

  // Purchase Order Line Item Crud
  purchaseOrderLineItemRoutes,
  purchaseOrderLineItemCrud,

  // Merge Asset Crud
  mergeAssetRoutes,
  mergeAssetCrud,

  // Split Allocate Asset Crud
  splitAllocateAssetRoutes,
  splitAllocateAssetCrud,

  // Check Version Crud
  checkVersionRoutes,
  checkVersionCrud,

  // Bulk Updates Crud
  bulkUpdateRoutes,
  bulkUpdateCrud,

  // Custom Report Crud
  customReportRoutes,
  customReportCrud,

  // Service Crud
  serviceRoutes,
  serviceCrud,

  // Contract Service Connection Crud
  contractServiceConnectionRoutes,
  contractServiceConnectionCrud,

  // Contract Category Consignment Rule Crud
  contractCategoryConsignmentRuleRoutes,
  contractCategoryConsignmentRuleCrud,

  // Settlement Report Crud
  projectSettlementReportRoutes,
  projectSettlementReportCrud,

  // Service Hour Crud
  serviceHourRoutes,
  serviceHourCrud,

  // Super Admin User Crud
  superAdminUserRoutes,
  superAdminUserCrud,

  // User invite email Crud
  userInviteEmailRoutes,
  userInviteEmailCrud,

  // Super Admin invite email crud
  superAdminUserInviteEmailRoutes,
  superAdminUserInviteEmailCrud,

  // Asset Status Activity Crud
  assetStatusActivityRoutes,
  assetStatusActivityCrud,

  // User Asset Activity Crud
  userAssetActivityRoutes,
  userAssetActivityCrud,

  // Asset Transaction Crud
  assetTransactionRoutes,
  assetTransactionCrud,

  // generic re-export types
  type DeleteAddressParams,
  type DeleteApiKeyParams,
  type DeleteAssetParams,
  type DeleteAttributeConnectionParams,
  type DeleteAttributeParams,
  type DeleteAttributeSetParams,
  type DeleteAttributeValueParams,
  type DeleteCategoryParams,
  type DeleteCommoditiesOnContractsParams,
  type DeleteCommodityParams,
  type DeleteCompanyParams,
  type DeleteContactParams,
  type DeleteContractParams,
  type DeleteDashboardParams,
  type DeleteDeploymentLineItemParams,
  type DeleteDeploymentParams,
  type DeleteFindSkuParams,
  type DeleteIncomingShipmentParams,
  type DeleteIncomingShipmentReportParams,
  type DeleteLocationParams,
  type DeleteManufacturerParams,
  type DeleteManyAddressParams,
  type DeleteManyApiKeyParams,
  type DeleteManyAssetParams,
  type DeleteManyAttributeConnectionParams,
  type DeleteManyAttributeParams,
  type DeleteManyAttributeSetParams,
  type DeleteManyAttributeValueParams,
  type DeleteManyCategoryParams,
  type DeleteManyCommoditiesOnContractsParams,
  type DeleteManyCommodityParams,
  type DeleteManyCompanyParams,
  type DeleteManyContactParams,
  type DeleteManyContractParams,
  type DeleteManyDashboardParams,
  type DeleteManyDeploymentLineItemParams,
  type DeleteManyDeploymentParams,
  type DeleteManyFindSkuParams,
  type DeleteManyIncomingShipmentParams,
  type DeleteManyIncomingShipmentReportParams,
  type DeleteManyLocationParams,
  type DeleteManyManufacturerParams,
  type DeleteManyMasterItemParams,
  type DeleteManyNotificationTypeParams,
  type DeleteManyPermissionParams,
  type DeleteManyPortalCompanyParams,
  type DeleteManyPrintParams,
  type DeleteManyPrintTemplateParams,
  type DeleteManyPrinterParams,
  type DeleteManyProjectParams,
  type DeleteManyProjectTypeFieldConnectionParams,
  type DeleteManyProjectTypeParams,
  type DeleteManyReturnLineItemParams,
  type DeleteManyReturnParams,
  type DeleteManyRoleParams,
  type DeleteManyRoleResourceParams,
  type DeleteManyRolesOnUsersParams,
  type DeleteManySalesOrderLineItemParams,
  type DeleteManySalesOrderParams,
  type DeleteManySkidParams,
  type DeleteManySpaceParams,
  type DeleteManySpaceSendgridParams,
  type DeleteManySpaceSubdomainParams,
  type DeleteManyUploadParams,
  type DeleteManyUserParams,
  type DeleteManyUserTablePreferencesParams,
  type DeleteManyUsersRoleParams,
  type DeleteManyVendorConnectionParams,
  type DeleteManyVendorParams,
  type DeleteManyVendorTypeParams,
  type DeleteManyWarehouseParams,
  type DeleteManyWorkflowStepParams,
  type DeleteManyWorkflowTransitionParams,
  type DeleteMasterItemParams,
  type DeleteNotificationTypeParams,
  type DeletePermissionParams,
  type DeletePortalCompanyParams,
  type DeletePrintParams,
  type DeletePrintTemplateParams,
  type DeletePrinterParams,
  type DeleteProjectParams,
  type DeleteProjectTypeFieldConnectionParams,
  type DeleteProjectTypeParams,
  type DeleteReturnLineItemParams,
  type DeleteReturnParams,
  type DeleteRoleParams,
  type DeleteRoleResourceParams,
  type DeleteRolesOnUsersParams,
  type DeleteSalesOrderLineItemParams,
  type DeleteSalesOrderParams,
  type DeleteSkidParams,
  type DeleteSpaceParams,
  type DeleteSpaceSendgridParams,
  type DeleteSpaceSubdomainParams,
  type DeleteUploadParams,
  type DeleteUserParams,
  type DeleteUserTablePreferencesParams,
  type DeleteUsersRoleParams,
  type DeleteVendorConnectionParams,
  type DeleteVendorParams,
  type DeleteVendorTypeParams,
  type DeleteWarehouseParams,
  type DeleteWorkflowStepParams,
  type DeleteWorkflowTransitionParams,
  type Filter,
  type GetAddressParams,
  type GetAllSettings,
  type GetApiKeyParams,
  type GetAssetParams,
  type GetAttributeConnectionParams,
  type GetAttributeParams,
  type GetAttributeSetParams,
  type GetAttributeValueParams,
  type GetCategoryParams,
  type GetCommoditiesOnContractsParams,
  type GetCommodityParams,
  type GetCompanyParams,
  type GetContactParams,
  type GetContractParams,
  type GetDashboardParams,
  type GetDeploymentLineItemParams,
  type GetDeploymentParams,
  type GetFindSkuParams,
  type GetIncomingShipmentParams,
  type GetIncomingShipmentReportParams,
  type GetLocationParams,
  type GetManufacturerParams,
  type GetMasterItemParams,
  type GetNotificationTypeParams,
  type GetPermissionParams,
  type GetPortalCompanyParams,
  type GetPrintParams,
  type GetPrintTemplateParams,
  type GetPrinterParams,
  type GetProjectParams,
  type GetProjectTypeFieldConnectionParams,
  type GetProjectTypeParams,
  type GetReturnLineItemParams,
  type GetReturnParams,
  type GetRoleParams,
  type GetRoleResourceParams,
  type GetRolesOnUsersParams,
  type GetSalesOrderLineItemParams,
  type GetSalesOrderParams,
  type GetSkidParams,
  type GetSpaceParams,
  type GetSpaceSendgridParams,
  type GetSpaceSubdomainParams,
  type GetUploadParams,
  type GetUserParams,
  type GetUserTablePreferencesParams,
  type GetUsersRoleParams,
  type GetVendorConnectionParams,
  type GetVendorParams,
  type GetVendorTypeParams,
  type GetWarehouseParams,
  type GetWorkflowStepParams,
  type GetWorkflowTransitionParams,
  type PutAddressParams,
  type PutApiKeyParams,
  type PutAssetParams,
  type PutAttributeConnectionParams,
  type PutAttributeParams,
  type PutAttributeSetParams,
  type PutAttributeValueParams,
  type PutCategoryParams,
  type PutCommoditiesOnContractsParams,
  type PutCommodityParams,
  type PutCompanyParams,
  type PutContactParams,
  type PutContractParams,
  type PutDashboardParams,
  type PutDeploymentLineItemParams,
  type PutDeploymentParams,
  type PutFindSkuParams,
  type PutIncomingShipmentParams,
  type PutIncomingShipmentReportParams,
  type PutLocationParams,
  type PutManufacturerParams,
  type PutManyAddressParams,
  type PutManyApiKeyParams,
  type PutManyAssetParams,
  type PutManyAttributeConnectionParams,
  type PutManyAttributeParams,
  type PutManyAttributeSetParams,
  type PutManyAttributeValueParams,
  type PutManyCategoryParams,
  type PutManyCommoditiesOnContractsParams,
  type PutManyCommodityParams,
  type PutManyCompanyParams,
  type PutManyContactParams,
  type PutManyContractParams,
  type PutManyDashboardParams,
  type PutManyDeploymentLineItemParams,
  type PutManyDeploymentParams,
  type PutManyFindSkuParams,
  type PutManyIncomingShipmentParams,
  type PutManyIncomingShipmentReportParams,
  type PutManyLocationParams,
  type PutManyManufacturerParams,
  type PutManyMasterItemParams,
  type PutManyNotificationTypeParams,
  type PutManyPermissionParams,
  type PutManyPortalCompanyParams,
  type PutManyPrintParams,
  type PutManyPrintTemplateParams,
  type PutManyPrinterParams,
  type PutManyProjectParams,
  type PutManyProjectTypeFieldConnectionParams,
  type PutManyProjectTypeParams,
  type PutManyReturnLineItemParams,
  type PutManyReturnParams,
  type PutManyRoleParams,
  type PutManyRoleResourceParams,
  type PutManyRolesOnUsersParams,
  type PutManySalesOrderLineItemParams,
  type PutManySalesOrderParams,
  type PutManySkidParams,
  type PutManySpaceParams,
  type PutManySpaceSendgridParams,
  type PutManySpaceSubdomainParams,
  type PutManyUploadParams,
  type PutManyUserParams,
  type PutManyUserTablePreferencesParams,
  type PutManyUsersRoleParams,
  type PutManyVendorConnectionParams,
  type PutManyVendorParams,
  type PutManyVendorTypeParams,
  type PutManyWarehouseParams,
  type PutManyWorkflowStepParams,
  type PutManyWorkflowTransitionParams,
  type PutMasterItemParams,
  type PutNotificationTypeParams,
  type PutPermissionParams,
  type PutPortalCompanyParams,
  type PutPrintParams,
  type PutPrintTemplateParams,
  type PutPrinterParams,
  type PutProjectParams,
  type PutProjectTypeFieldConnectionParams,
  type PutProjectTypeParams,
  type PutReturnLineItemParams,
  type PutReturnParams,
  type PutRoleParams,
  type PutRoleResourceParams,
  type PutRolesOnUsersParams,
  type PutSalesOrderLineItemParams,
  type PutSalesOrderParams,
  type PutSkidParams,
  type PutSpaceParams,
  type PutSpaceSendgridParams,
  type PutSpaceSubdomainParams,
  type PutUploadParams,
  type PutUserParams,
  type PutUserTablePreferencesParams,
  type PutUsersRoleParams,
  type PutVendorConnectionParams,
  type PutVendorParams,
  type PutVendorTypeParams,
  type PutWarehouseParams,
  type PutWorkflowStepParams,
  type PutWorkflowTransitionParams,
  type Query,
  type RequestFilter,
  type UploadAddressParams,
  type UploadApiKeyParams,
  type UploadAssetParams,
  type UploadAttributeConnectionParams,
  type UploadAttributeParams,
  type UploadAttributeSetParams,
  type UploadAttributeValueParams,
  type UploadCategoryParams,
  type UploadCommoditiesOnContractsParams,
  type UploadCommodityParams,
  type UploadCompanyParams,
  type UploadContactParams,
  type UploadContractParams,
  type UploadDashboardParams,
  type UploadDeploymentLineItemParams,
  type UploadDeploymentParams,
  type UploadFindSkuParams,
  type UploadIncomingShipmentParams,
  type UploadIncomingShipmentReportParams,
  type UploadLocationParams,
  type UploadManufacturerParams,
  type UploadMasterItemParams,
  type UploadNotificationTypeParams,
  type UploadPermissionParams,
  type UploadPortalCompanyParams,
  type UploadPrintParams,
  type UploadPrintTemplateParams,
  type UploadPrinterParams,
  type UploadProjectParams,
  type UploadProjectTypeFieldConnectionParams,
  type UploadProjectTypeParams,
  type UploadReturnLineItemParams,
  type UploadReturnParams,
  type UploadRoleParams,
  type UploadRoleResourceParams,
  type UploadRolesOnUsersParams,
  type UploadSalesOrderLineItemParams,
  type UploadSalesOrderParams,
  type UploadSkidParams,
  type UploadSpaceParams,
  type UploadSpaceSendgridParams,
  type UploadSpaceSubdomainParams,
  type UploadUploadParams,
  type UploadUserParams,
  type UploadUserTablePreferencesParams,
  type UploadUsersRoleParams,
  type UploadVendorConnectionParams,
  type UploadVendorParams,
  type UploadVendorTypeParams,
  type UploadWarehouseManyParams,
  type UploadWorkflowStepParams,
  type UploadWorkflowTransitionParams,
  type GetPortalLocationParams,
  type PutPortalLocationParams,
  type PutManyPortalLocationParams,
  type DeletePortalLocationParams,
  type DeleteManyPortalLocationParams,
  type UploadPortalLocationParams,
  type GetProjectSalesOrdersParams,
  type GetWipeOSAttributeParams,
  type PutWipeOSAttributeParams,
  type PutManyWipeOSAttributeParams,
  type IncomingShipmentReportRecordCountRoutes,
  type GetIncomingShipmentReportRecordCountParams,
  type R2GradingOptionRoutes,
  type GetR2GradingOptionParams,
  type PutR2GradingOptionParams,
  type PutManyR2GradingOptionParams,
  type DeleteR2GradingOptionParams,
  type DeleteManyR2GradingOptionParams,
  type UploadR2GradingOptionParams,
  type GetSalesOrderReportParams,
  type GetHistoryParams,
  type GetAssetHistoryParams,
  type GetCustomReportParams,
  type PutCustomReportParams,
  type PutManyCustomReportParams,
  type DeleteCustomReportParams,
  type DeleteManyCustomReportParams,
  type UploadCustomReportParams,
  type GetParamsWithSpace,
  type GetParams,
};
